import React from 'react';
import PropTypes from 'prop-types';
import {CloseButton} from '@learningblocks/storybook-components';
import './style.scss';

/**
 * Header:
 *  - Header for LabelTestTube Component
 */
export function Header(props) {
  return (
    <div className='component_header'>
      <h4 className='component_header__label'>{props.label}</h4>
      <CloseButton
        className='component_header__close'
        close={props.close}
        size={props.size}
      />
    </div>
  );
}

Header.propTypes = {
  /**
   * label of the componet
   */
  label: PropTypes.string,
  /**
   * Callback function to invoke when you wanna close the Questio Modal Window
   */
  close: PropTypes.func,
};

Header.defaultprops = {
  size: 'md',
};
